import type { IPath } from '@alfa-bank/site-breadcrumbs/src/models';
import type { TTooltipsAssetGroups } from '@alfa-bank/site-invest-emitents-common/src/models';

export const defaultAnchorLink = '#Form-Open-Acc';

export const primaryButtonText = 'Открыть счёт';

export const defaultBreadcrumbs: IPath[] = [
    {
        id: 1,
        link: '/',
        title: 'Частным лицам',
    },
    {
        id: 2,
        link: '/make-money/investments/',
        title: 'Инвестиции',
    },
];

export const textData = {
    bondHeader: 'Информация о купоне',
    siteLinkText: 'Официальный сайт',
};

export const dataTestIds = {
    aboutAssetContainer: 'about-asset-container',
    isVisibleContainer: 'about-asset-container',
    assetHeaderContainer: 'asset-header-container',
    bondInfoContainer: 'bond-info-container',
    assetGroupLabel: 'asset-group-label',
    assetGroupLabelTooltip: 'asset-group-label-tooltip',
    assetGroupCard: 'asset-group-card',
    dividendBannerContainer: 'dividend-banner',
};

export const defaultTooltipAssetGroups: TTooltipsAssetGroups = {
    IMOEX: 'Акция входит в состав индекса Московской Биржи',
    MOEXBC: 'Акция входит в состав голубых фишек Московской Биржи',
};

export const defaultDividendCardTexts = {
    title: 'Купите до',
    description: 'Чтобы получить дивиденды',
};

export const defaultDividendBannerTexts = {
    cells: {
        profitabilityPercentDesktop: {
            title: 'Дивидендная доходность',
        },
        profitabilityPercentMobile: {
            title: 'Доходность',
        },
        dividendValue: {
            title: 'Выплата на 1 акцию',
        },
        payDate: {
            title: 'Прогнозируемая дата выплаты',
            hint: 'Номинальные владельцы получают в течение 10 рабочих дней с даты реестра',
        },
    },
    paymentType: 'ДИВИДЕНДЫ',
    title: {
        desktop: 'Купите акцию до',
        mobile: 'Купите акцию \nдо',
    },
};
